import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from 'components/common'

import LanguageSelector from '../LanguageSelector'

import MCRLogo from 'mcr_logo.svg'

import './TopNav.scss'
import FAQModal from './FAQModal'

const TopNavPublic = ({ freeTrial }: { freeTrial?: boolean }) => {
  const { t } = useTranslation('pub', {
    keyPrefix: 'PublicRoutes',
  })
  const [isFaqOpen, setIsFaqOpen] = useState(false)

  // note: depending on which landing page the user goes to we either
  // want them to go the cardholder signup flow or the access code signup flow
  const location = useLocation()
  const isCardBenefitPage = location.pathname.replace(/\/$/, '') === '/card-benefit'
  const signupPath =
    isCardBenefitPage ? '/card-benefit/sign-up' : '/sign-up'
  const logoLink = location.pathname.startsWith('/card-benefit')
    ? '/card-benefit'
    : '/'

  const openFaq = () => {
    setIsFaqOpen(true)
  }

  return (
    <>
      <nav role="navigation" id="top-nav">
        <div className="nav-body">
          <div className="nav-left">
            {freeTrial ? (
              <div className="navbar-logo">
                <img src={MCRLogo} className="logo-svg" alt="Logo" />
              </div>
            ) : (
              <Link to={logoLink} className="navbar-logo">
                <img src={MCRLogo} className="logo-svg" alt="Logo" />
              </Link>
            )}
          </div>
          <div className="nav-right">
            <div className="nav-items">
              <div className="public-button-group">
                {isCardBenefitPage ? (
                  <Button className="faq" color="blue outline" onClick={openFaq}>
                    {t('faq.frequentlyAskedQuestions')}
                  </Button>
                ) : null}
                <Button className="login" color="blue outline">
                  <Link to="/login">{t('topNav.logIn')}</Link>
                </Button>
                <Button className="signup" color="blue">
                  <Link to={signupPath}>
                    {t('welcome.getStarted')}
                  </Link>
                </Button>
              </div>
              <LanguageSelector />
            </div>
          </div>
        </div>
      </nav>
      <FAQModal isFaqOpen={isFaqOpen} setIsFaqOpen={setIsFaqOpen} />
    </>
  )
}

export default TopNavPublic
